import { SCREEN_SIZES } from '@/shared/config/ui';

const PORTRAIT_MOBILE_WORLD_SCALE = 2;

export const getLaneWorldScale = (screenWidth: number, screenHeight: number): number => {
	return screenWidth < SCREEN_SIZES.MOBILE && screenHeight > screenWidth ? PORTRAIT_MOBILE_WORLD_SCALE : 1;
};

export const getLaneCameraScrollX = ({
	targetX,
	worldWidth,
	viewportWidth,
}: {
	targetX: number;
	worldWidth: number;
	viewportWidth: number;
}): number => {
	const maxScrollX = Math.max(0, worldWidth - viewportWidth);
	return Math.min(maxScrollX, Math.max(0, targetX - viewportWidth / 2));
};

export const getLaneBottomPct = (screenWidth: number): number => {
	if (screenWidth < SCREEN_SIZES.MOBILE) {
		return 130;
	}
	return screenWidth < SCREEN_SIZES.TABLET ? 110 : 95;
};

export const getLaneTopPct = (screenWidth: number): number => {
	if (screenWidth < SCREEN_SIZES.MOBILE) {
		return 60;
	}
	return screenWidth < SCREEN_SIZES.TABLET ? 50 : 40;
};

export function computeBottomLaneCenters({
	width,
	lanes,
	laneBottomPct,
}: {
	width: number;
	lanes: number;
	laneBottomPct: number;
}): number[] {
	const safeWidth = Math.max(1, width);
	const lanesCount = Math.max(1, Math.min(4, Math.round(lanes || 4)));
	const bottomWidthPx = (safeWidth * Math.max(18, laneBottomPct)) / 100;
	const leftX = safeWidth / 2 - bottomWidthPx / 2;

	const shiftTowardLeftLine = lanesCount === 2 ? 0.2 : 0.25;
	const shiftTowardRightLine = lanesCount === 2 ? -0.2 : -0.25;
	const secondBoxLeftNudge = 0.02;
	const thirdBoxRightNudge = -0.02;

	return Array.from({ length: lanesCount }, (_, laneIndex) => {
		const baseFraction = (laneIndex + 0.5) / lanesCount;
		let withinLaneShift = 0;

		if (laneIndex === 0 && lanesCount > 1) {
			withinLaneShift = shiftTowardLeftLine / lanesCount;
		} else if (laneIndex === lanesCount - 1 && lanesCount > 1) {
			withinLaneShift = shiftTowardRightLine / lanesCount;
		} else if (laneIndex === 1) {
			withinLaneShift = secondBoxLeftNudge;
		} else if (laneIndex === 2) {
			withinLaneShift = thirdBoxRightNudge;
		}

		const fraction = Math.min(0.98, Math.max(0.01, baseFraction + withinLaneShift));
		return leftX + fraction * bottomWidthPx;
	});
}
